import { useEffect } from 'react';

// Captura Cmd+K (Mac) e Ctrl+K (Win/Linux) em qualquer lugar da página.
// Ignora se o usuário está digitando num input/textarea/contenteditable
// — exceto para o próprio K-modifier, que sempre passa.
export function useCmdK(onTrigger) {
  useEffect(() => {
    function handler(e) {
      const isK = e.key === 'k' || e.key === 'K';
      if (!isK) return;
      const isCmdOrCtrl = e.metaKey || e.ctrlKey;
      if (!isCmdOrCtrl) return;
      e.preventDefault();
      onTrigger();
    }
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [onTrigger]);
}
